<template>
    <div>
        <div class="card-body text-center">
            <button @click="releaseTrade()" class="btn btn-info" type="button">Release Payment</button>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Only release payment when you have received the commodities. This action is non-reversible. If you wish to dispute this transaction, please click on Open Dispute button below.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Release",
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {}
        },
        beforeMount() {
        },
        methods: {
            async releaseTrade() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/release', {comments: ''});
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Funds are released from escrow.', 'Escrow released');
                    this.events.$emit('trade:reload');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Release escrow failed', 'Failure');
                }
            }
        }
    }
</script>

<style scoped>

</style>
